<p-toast />
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>

<div class="container-casosclinicos">
    <h2 style="text-align: center;">Casos clínicos</h2>
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Nuevo Caso Clinico'" icon="pi pi-plus"
                (click)="nuevoCasoClinico()"></button>
        </ng-template>
        <ng-template pTemplate="right">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>


    <p-table [value]="casosClinicos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Caso Clínico</th>
                <th>Paciente</th>
                <th>Cirugia</th>
                <th>Hospital</th>
                <th>Productos - Documentos</th>
                <th colspan="2">Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-casoclinico>
            <tr>
                <td>{{casoclinico.fecha}}</td>
                <td>{{casoclinico.serie}}</td>
                <td>{{casoclinico.paciente}}</td>
                <td>{{casoclinico.nomCuerpo}}</td>
                <td>{{casoclinico.nomHospital}}</td>
                <td>{{casoclinico.productos.length}} - {{casoclinico.documentos.length}}</td>
                <td>
                    <a [routerLink]="['/medico/casoclinico', casoclinico.id]">
                        <i class="pi pi-pencil" style="color: slateblue"></i>
                    </a>
                </td>
                <td>
                    <ng-template [ngIf]="casoclinico.productos.length == 0 && casoclinico.documentos.length == 0">
                        <p-button icon="pi pi-trash"
                            styleClass="p-button-rounded p-button-danger p-button-text p-button-sm"
                            (click)="deleteCasoClinico(casoclinico.id)"></p-button>
                    </ng-template>

                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron casos clinicos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>